export default {
  identity: {
    header: 'Identity Theft Protection',
    body: `<div class="title-sm">Get Back to Being Yourself</div>
<p>Identity Theft has become the fastest growing white-collar crime in America.
All it takes is your name, social security number, and date of birth, and a thief can apply for everything from a
credit card or a bank loan to even an insurance policy. Having your identity stolen damages your sense of security,
but the real hardship may be how difficult, time-consuming, and expensive
it can be to restore your credit and get your life back on track.</p>
<p>Identity Theft coverage from SIG & Associates is a simple and affordable way to protect you and your family from this growing threat.
By adding ID coverage to your current Homeowners, Condo, or Renters Insurance policy,
you’ll receive invaluable tools to help cover the costs and expenses of restoring your identity.</p>
<p>Included in a policy with Identity Theft protection are expenses associated with:</p>

<ul>
<li>Attorney Fees</li>
<li>Costs of Certified Mail</li>
<li>Loan Re-Application Fees</li>
<li>Costs of Long Distance Phone Calls</li>
<li>Reimbursement for Lost Income</li>
<li>Costs of Executing Affidavits</li>
</ul>

<div class="title-sm">Our Goal is to Secure Your Identity</div>
<p>In addition to helping you get your finances back in line, SIG & Associates also offers some of the best service in the industry,
with round-the-clock assistance from experienced professionals.
Our Identity Fraud specialists will work with you one-on-one to quickly assess your situation and take action to:</p>

<ul>
<li>Stop further damage to your credit by contacting major credit bureaus</li>
<li>Make all required phone calls to creditors, banks, and agencies with whom you do business</li>
<li>Assist in replacing valuable documents like your driver’s license, passport, or social security card</li>
<li>Provide an emergency cash advance if theft occurs while away from home</li>
</ul>

<p>Having your identity stolen is frustrating enough. Having to recover and restore your credit and finances should not have to be.
 Talk with a specialist at SIG & Associates to learn how Identity Theft coverage can help save you time, money, and a whole lot of pain.</p>
<p><small><i>*Restrictions and limits apply</i></small></p>
`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  umbrella: {
    header: 'Personal Umbrella Insurance',
    body: `<div class="title-sm">Be Ready for Anything and Everything</div>
<p>Personal Umbrella Liability is one of the most commonly overlooked policies, but in the case of a catastrophic financial event,
it could be the best line of defense you’ll ever have. If you’re involved a major auto accident or if someone gets injured on your property,
you could be sued for damages well beyond the liability coverage provided by your Home and Auto Insurance policies.</p>
<p>In such a critical situation, having Personal Umbrella Insurance from SIG & Associates will protect your home, car,
future wages, and all of your priceless assets from being used to pay for the expenses.</p>

<div class="title-sm">Coverage That Keeps You Protected</div>
<p>Your Umbrella Liability policy from SIG & Associates works to give you additional protection when damages exceed the liability coverage of your standard policies.
It also offers extra security for many situations that may not be included in your basic insurance.</p>

<p>Personal Umbrella insurance can be applied to events such as:</p>
<ul>
<li>Car Accidents</li>
<li>Accidental injuries on your property</li>
<li>Accidents involving your boat, ATV, or other recreational vehicle</li>
<li>Golf Course Injuries</li>
<li>Defense fees and other legal costs</li>
<li>Personal Injury Coverage for claims of libel, slander, and more</li>
</ul>
<p>At SIG & Associates, we are committed to the safety and security of you and your family,
which is why we will work with you to create a perfect policy that protects all of your interests.
Since Personal Umbrella Insurance will vary depending on your individual coverage needs,
it’s important to discuss your options with one of our insurance specialists before making a decision.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  data: {
    header: 'Data Backup',
    body: `<div class="title-sm">Insurance of a Different Kind</div>
<p>Technology has made keeping up-to-date records of your personal finances, assets, and business documents easier than ever.
No longer do you have to deal with scattered papers and overfilled filing cabinets.
Instead, you can keep all of your most precious information neatly organized and secure on your own personal or business computer.
</p>
<p>Unfortunately, accidents can also happen in the virtual world – from hackers to technological malfunctions.
That’s why it’s important to be prepared, so you can keep your documents safe.</p>
<p>Data Backup is a specialty service from SIG & Associates that ensures the safety of your electronic records,
documents, and other important files by periodically backing them up for you to our secure server.
It can save you time and money, as well as protect you from major information loss.</p>
<p>To learn more about Data Backup as well as our other distinctive services, contact SIG & Associates today.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  pet: {
    header: 'Pet Insurance',
    body: `<div class="title-sm">Give your entire family the protection they deserve</div>
<p>Every member of your family deserves protection, which is why SIG & Associates
is proud to offer Pet Insurance through several A-rated carriers, such as [insert 2-3 carriers].</p>

<p>Pet Medical Bills are becoming increasingly more expensive as new veterinary technologies and medicines emerge.
With a Pet Insurance Policy from SIG & Associates, you can get reimbursed for your dog or cat’s unexpected medical bills and have peace of mind when illness or injury strikes.</p>

<ul>
<li>Emergency surgeries</li>
<li>Diagnostic tests</li>
<li>Medications</li>
<li>Treatments</li>
<li>Hospital stays and more</li>
</ul>

<div class="title-sm">Knowledgeable Agents Keeping Pets Secure</div>
<p>The agents at SIG & Associates know how important it is for your pets to be covered should any unforeseen sicknesses or injuries arise.
Contact us to learn more about our Pet Insurance coverage options or click here to fetch a quote.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/personalHelper.js